// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__UkYaZ"};